module.exports = __webpack_public_path__ + "img/about-banner-mini.52f60a12.png";